import { useCallback, useMemo, useState } from 'react';
import { useQueryGetProjectTeamMember, useQueryListProjectTeamMembers } from '../../team.queries';
import { TeamMemberDetailsActions } from '../actions/team-member-details.actions';
import { useTeamMemberStatusChange } from './team-member-status-change.hook';

export function useTeamMemberDetails(projectID: string, teamMemberID: string) {
  const [currentAction, setCurrentAction] = useState<TeamMemberDetailsActions | null>(null);
  const team = useQueryListProjectTeamMembers(projectID);
  const teamMember = useQueryGetProjectTeamMember(projectID, teamMemberID);

  const user = useMemo(
    () => (teamMember.data ? teamMember.data : (team.data || []).find((u) => u.accountID === teamMemberID)),
    [team, teamMember, teamMemberID]
  );

  const { suspendUser, activateUser } = useTeamMemberStatusChange(
    setCurrentAction,
    teamMember.data?.accountID,
    projectID
  );

  const setAction = useCallback(
    (action: TeamMemberDetailsActions | null) => {
      switch (action) {
        case TeamMemberDetailsActions.SUSPEND_USER:
          return suspendUser();
        case TeamMemberDetailsActions.ACTIVATE_USER:
          return activateUser();
        default:
          return setCurrentAction(action);
      }
    },
    [suspendUser, activateUser]
  );

  return [
    {
      data: user,
      isLoading: team.isLoading && teamMember.isLoading,
      error: team.error || teamMember.error
    },
    {
      currentAction,
      setAction
    }
  ] as const;
}
